import React from "react";
import { ITextFieldStyles, IDropdownStyles, IButtonStyles, ICheckboxStyles } from "@fluentui/react";

export const styles: Record<string, React.CSSProperties> = {
    page: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
    },
    top: {
        alignSelf: 'center',
    },
    middle: {
        flex: '1 1 100%',
        minWidth: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    bottom: {
        alignSelf: 'center',
        marginBottom: 20,
    },
};

export const textFieldStyles: Partial<ITextFieldStyles> = {
    fieldGroup: {
        height: 40
    },
    field: {
        fontSize: 14,
        padding: 10
    },
    subComponentStyles: {
        label: {
            root: {
                fontWeight: 'thin'
            }
        }
    }
};

export const dropdownStyles: Partial<IDropdownStyles> = {
    label: {
        fontWeight: 'thin'
    },
    dropdown: {
        borderColor: 'white',
    },
    title: {
        height: 40,
        paddingTop: 5,
    },
    caretDown: {
        color: 'blue',
        paddingTop: 5,
        paddingRight: 5
    },
    dropdownItem: {
        backgroundColor: 'white',
    },
    dropdownItemSelected: {
        backgroundColor: 'rgb(240, 247, 255)',
        color: 'black',
    }
};

export const checkboxStyles: Partial<ICheckboxStyles> = {
    checkbox: {
        selectors: {
            '.is-checked &': {
                backgroundColor: 'black',
                borderColor: 'black',
                color: 'rgb(228, 210, 107)'
            },
            '.is-checked:hover &': {
                backgroundColor: 'black'
            }
        }
    }
    //checkboxChecked: {
    //    backgroundColor: 'black',
    //    borderColor: 'black',
    //    color: 'rgb(228, 210, 107)'
    //}
}

export const primaryButtonStyles: Partial<IButtonStyles> = {
    root: {
        backgroundColor: 'black',
        color: 'rgb(228, 210, 107)',
        borderRadius: 6,
        height: 40,
        width: "100%"
    },
    rootHovered: {
        backgroundColor: 'black'
    },
    rootPressed: {
        backgroundColor: 'black',
    },
    label: {
        //fontWeight: 600,
        //fontSize: 14,
    },
};

export const defaultButtonStyles: Partial<IButtonStyles> = {
    root: {
        backgroundColor: 'white',
        color: 'black',
        borderRadius: 6,
        height: 40,
        width: "100%"
    }
};